import { ChangeRequestStatusTypes } from "@enums/change-request-status-types";

export const injectRpServiceId = (route: string, rpServiceId: string) => {
    return route.replace(":rpServiceId", rpServiceId);
};

export const injectAxnAdminSecurityRuleId = (route: string, securityRuleId: string) => {
    return route.replace(":axnAdminSecurityRuleId", securityRuleId);
};

export const injectAttributeLabelId = (route: string, attributeLabelId: string) => {
    return route.replace(":attributeLabelId", attributeLabelId);
};

export const injectWorkflowTemplateId = (route: string, workflowTemplateId: string) => {
    return route.replace(":workflowTemplateId", workflowTemplateId);
};

export const injectIdentityProviderId = (route: string, identityProviderId: string) => {
    return route.replace(":identityProviderId", identityProviderId);
};

export const injectRelyingPartyId = (route: string, relyingPartyId: string) => {
    return route.replace(":relyingPartyId", relyingPartyId);
};

export const injectAxnCompanyId = (route: string, axnCompanyId: string) => {
    return route.replace(":axnCompanyId", axnCompanyId);
};

export const injectIdentityProviderIdAndChangeRequestStatus = (route: string, identityProviderId: string, changeRequestStatus: ChangeRequestStatusTypes) => {
    return route.replace(":identityProviderId", identityProviderId).replace(":changeRequestStatus", changeRequestStatus);
};

export const injectRpServiceIdAndChangeRequestStatus = (route: string, rpServiceId: string, changeRequestStatus: ChangeRequestStatusTypes) => {
    return route.replace(":rpServiceId", rpServiceId).replace(":changeRequestStatus", changeRequestStatus);
};

export const injectWorkflowIdAndChangeRequestStatus = (route: string, workflowId: string, changeRequestStatus: ChangeRequestStatusTypes) => {
    return route.replace(":workflowId", workflowId).replace(":changeRequestStatus", changeRequestStatus);
};

export const injectAxnAdminUserId = (route: string, axnAdminUserId: string) => {
    return route.replace(":axnAdminUserId", axnAdminUserId);
};

export const injectAxnAdminUserInvitationId = (route: string, axnAdminUserInvitationId: string) => {
    return route.replace(":axnAdminUserInvitationId", axnAdminUserInvitationId);
};

export const injectAxnAttributeLabelId = (route: string, axnAttributeLabelId: string) => {
    return route.replace(":axnAttributeLabelId", axnAttributeLabelId);
};

export const injectWorkflowId = (route: string, workflowId: string) => {
    return route.replace(":workflowId", workflowId);
};

export const injectProfileId = (route: string, profileId: string) => {
    return route.replace(":profileId", profileId);
};

export const injectTransactionId = (route: string, transactionId: string) => {
    return route.replace(":transactionId", transactionId);
};

export const injectCustomIdParameter = (route: string, id: string, pattern: string) => {
    if (route.includes(pattern)) {
        return route.replace(`:${pattern}`, id);
    }

    return route;
};
